import {CssBaseline, Grid, ThemeProvider, useMediaQuery} from "@mui/material";
import React, {Suspense} from "react";
import themeFile from "./config/theme";
import RTL from "./RTL";
import "./utils/global"
import globalRoutes from "./globalRoutes";
import RoutePage from "./container/RoutePage";
import CenterPage from "./container/CenterPage";
import MyLoading from "./component/base/MyLoading";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {setInterceptors} from "./api/api";
import {useDispatch} from "react-redux";
import {logout} from "./store/user";
import LanguageGuard from "./LanguageGuard";
import {useTranslate} from "./locales/use-locales";

export default () => {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    const {currentLang} = useTranslate()
    const theme = React.useMemo(
        () => themeFile(prefersDarkMode,currentLang?.fontFamily),
        [prefersDarkMode,currentLang],
    );
    const dispatch = useDispatch()
    setInterceptors(() => dispatch(logout()))

    return <ThemeProvider theme={theme}>
        <CssBaseline/>
        <RTL>
            <ToastContainer
                position="bottom-center"
                autoClose={2500}
                hideProgressBar
                newestOnTop={false}
                closeOnClick={false}
                rtl
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={false}
                theme={prefersDarkMode ? "dark" : "light"}
            />
            <LanguageGuard>
                <Grid container flexDirection={"column"} minHeight={1} position={"absolute"}>
                    <Suspense fallback={<CenterPage><MyLoading/></CenterPage>}>
                        <RoutePage defaultRoute={"/"} routes={globalRoutes}/>
                    </Suspense>
                </Grid>
            </LanguageGuard>
        </RTL>
    </ThemeProvider>;
}
